import { render, staticRenderFns } from "./kur.vue?vue&type=template&id=2270de9b&"
import script from "./kur.vue?vue&type=script&lang=js&"
export * from "./kur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports